import { Flex, Switch, Tag, Tooltip, Typography } from "antd"
import { getTemplateTagColor } from "./templates";
import get from "lodash/get"
import { EditTwoTone } from "@ant-design/icons";
import { COLOR_PRIMARY } from "..";
const {Text}= Typography;
export const companyTemplateColumns = (updatePauseStatus, toggleTemplateForm) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Company",
    dataIndex: ["company", "name"],
    key: "company_name",
  },
  { title: "Reset Time",
     dataIndex: "reset_time", 
     key: "reset_time" },
    {
      title:"Template Type",
      dataIndex:"type",
      key:"type",
      render:(type)=>(
        <Tag color={getTemplateTagColor(get(type, "value"))}>
          <p>
          {get(type, "name")}
          </p>
        </Tag>
      )
    },
    {
      title:"Last Synced", 
      dataIndex:"last_synced",
      key:"last_synced",
      render: (lastSynced) => <Tag>{lastSynced}</Tag>,
    },
    {
      title:"Pause",
      key:"pause_status",
      dataIndex:"status",
      render:(status, record)=>(
        <Flex justify="center" align="center">
          <Switch size="small" value={status} onChange={value=> {
            updatePauseStatus(get(record, "id"), {status:value})
          }}
          checkedChildren={<Text className="text-white" style={{ fontSize: '10px' }}>Pause</Text>}
            unCheckedChildren={<Text className="text-white" style={{ fontSize: '10px' }}>Resume</Text>}/>
        </Flex>
      )
    },
    {title:"Actions",
    key:"actions",
    dataIndex:"actions",
    render:(_,record)=>(
           <Tooltip title="Edit Company Template">
            <EditTwoTone
              style={{ fontSize: 20 }}
              twoToneColor={COLOR_PRIMARY}
              onClick={() => {
                toggleTemplateForm(record);
              }}
            />
          </Tooltip>
    )
    }
]